import $ from 'jquery';
import abgrcs_config from './abgrcs_config.js';

function Services() {
  return [
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-7">
        <div class="row mb-5">
        <div class="col-12 ">
        <h2 class="site-section-heading text-center">My Services</h2>
        </div>
        </div>
        </div>
      </div>,
      <div class="row">
        <div class="col-md-6 col-lg-6 col-xl-4 text-center mb-5 mb-lg-5">
          <div class="h-100 p-4 p-lg-5 site-block-feature-7">
            <span class="icon flaticon-camera display-3 text-primary mb-4 d-block"></span>
            <h3 class="text-white h4">Camera</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum exercitationem quae id dolorum debitis.</p>
            <p><strong class="font-weight-bold text-primary">$29</strong></p>
          </div>
        </div>
        <div class="col-md-6 col-lg-6 col-xl-4 text-center mb-5 mb-lg-5">
        <div class="h-100 p-4 p-lg-5 site-block-feature-7">
        <span class="icon flaticon-picture display-3 text-primary mb-4 d-block"></span>
        <h3 class="text-white h4">Wedding Photography</h3>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum exercitationem quae id dolorum debitis.</p>
        </div>
        </div>
        <div class="col-md-6 col-lg-6 col-xl-4 text-center mb-5 mb-lg-5">
        <div class="h-100 p-4 p-lg-5 site-block-feature-7">
        <span class="icon flaticon-sheep display-3 text-primary mb-4 d-block"></span>
        <h3 class="text-white h4">Animal</h3>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum exercitationem quae id dolorum debitis.</p>
        </div>
        </div>
        <div class="col-md-6 col-lg-6 col-xl-4 text-center mb-5 mb-lg-5">
        <div class="h-100 p-4 p-lg-5 site-block-feature-7">
        <span class="icon flaticon-frame display-3 text-primary mb-4 d-block"></span>
        <h3 class="text-white h4">Portrait</h3>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum exercitationem quae id dolorum debitis.</p>
        </div>
        </div>
        <div class="col-md-6 col-lg-6 col-xl-4 text-center mb-5 mb-lg-5">
        <div class="h-100 p-4 p-lg-5 site-block-feature-7">
        <span class="icon flaticon-eiffel-tower display-3 text-primary mb-4 d-block"></span>
        <h3 class="text-white h4">Travel</h3>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum exercitationem quae id dolorum debitis.</p>
        </div>
        </div>
        <div class="col-md-6 col-lg-6 col-xl-4 text-center mb-5 mb-lg-5">
        <div class="h-100 p-4 p-lg-5 site-block-feature-7">
        <span class="icon flaticon-video-play display-3 text-primary mb-4 d-block"></span>
        <h3 class="text-white h4">Video Editing</h3>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum exercitationem quae id dolorum debitis.</p>
        </div>
        </div>
      </div>
    </div>
  ];
}

export default Services;